import { HubSpotDeleteAction } from '../../enums/hubspot/hubspot-delete-action';
import {
	HubSpotAuthType,
	HubSpotConnectionDetails,
} from '../../interfaces/hubspot/hubspot-connection-details';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a HubspotDeleteObjects task.
 * Archives or permanently purges HubSpot objects by ID. The task processes
 * one object per record and always outputs ONE record { processingData: {} }.
 * Note: Purge is only supported for the Contacts object type.
 */
export class HubSpotDeleteObjectsConfig
	extends DestinationTaskConfigBase
	implements HubSpotConnectionDetails
{
	/** HubSpot private app access token. Supports expression syntax. Leave blank to use iHub credential store. @default '' */
	accessToken = '';
	/** HubSpot object type to delete (e.g. 'Contacts'). @default 'Contacts' */
	hubSpotObjectType = 'Contacts';
	/** Expression or field path resolving to the HubSpot object ID for each record. @default '' */
	idFieldMapping = '';
	/** Delete method. Archive=0 (soft delete), Purge=1 (permanent; Contacts only). @default HubSpotDeleteAction.Archive */
	deleteAction = HubSpotDeleteAction.Archive;
	/** When true, the access token is read from a flow variable instead of the accessToken field. */
	useVariableToken?: boolean;
	/** Chooses between a static/variable Private App token vs a reusable Web App OAuth connection. @default HubSpotAuthType.PrivateAppToken */
	authType: HubSpotAuthType = HubSpotAuthType.PrivateAppToken;
	/** Selected `OAuthConnectionConfig.id` (provider=HubSpot). WebApp auth only. */
	connectionID?: string;

	constructor(init?: Partial<HubSpotDeleteObjectsConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
